import { render, staticRenderFns } from "./CustomDialogHeader.vue?vue&type=template&id=3f900c8e&scoped=true"
import script from "./CustomDialogHeader.vue?vue&type=script&lang=js"
export * from "./CustomDialogHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomDialogHeader.vue?vue&type=style&index=0&id=3f900c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f900c8e",
  null
  
)

export default component.exports